import React from 'react';

export const AppSettingsContext = React.createContext();